import { createFileRoute } from "@tanstack/react-router";
import { ProductNotesPage } from "@/components/notes/NotesPages";

/** /p/KEY/notes: the notes of a product (for the space-wide product: the space's notes). */
export const Route = createFileRoute("/_app/p/$productKey/notes/")({ component: View });

function View() {
  const { productKey } = Route.useParams();
  return <ProductNotesPage productKey={productKey} />;
}
